
import React, { Component } from 'react'

import {NavLink, Link} from 'react-router-dom';

import Drawer from '@material-ui/core/Drawer';

import './header.css';

export default class Header extends Component {

  constructor(props){
    super(props);

    this.state = {
      isOpen: false
    };
  }

  toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({isOpen: open});
  };

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">

          <Drawer anchor={"left"} open={this.state.isOpen} onClose={this.toggleDrawer("left", false)}>
            <div className="drawer">
              <Link className="navbar-brand" to="/">
                  <img src="/images/logo-horizontal.png" alt=""/>
              </Link>
              <ul className="navbar-nav mr-auto">
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/pontos_interesse"><span>A aldeia</span></NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/essencia">Essência</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/aqui_perto"><span>Aqui perto</span></NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/noticias_e_eventos"><span>Notícias e Eventos</span></NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/restaurantes"><span>Restaurantes</span></NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/lojas"><span>Lojas</span></NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/alojamentos"><span>Alojamento</span></NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/comunidade">Comunidade</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/contactos">Contactos</NavLink>
                  </li>
              </ul>
            </div>
          </Drawer>
        <div className="container-fluid">

            <Link className="navbar-brand" to="/">
                <img id="layout-logo" src="/images/logo-horizontal.png" alt=""/>
            </Link>

            <button onClick={this.toggleDrawer("left", true)} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
        
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/pontos_interesse"><span>A aldeia</span></NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/essencia"><span>Essência</span></NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/aqui_perto"><span>Aqui perto</span></NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/noticias_e_eventos"><span>Notícias e Eventos</span></NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/restaurantes"><span>Restaurantes</span></NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/lojas"><span>Lojas</span></NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/alojamentos"><span>Alojamento</span></NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/comunidade">Comunidade</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/contactos">Contactos</NavLink>
                </li>
            </ul>
          </div>
        </div>
      </nav>
    )
  }
}
